export const LivePositionTexts = {
  CrewNeededInfo:
    "Damit andere Geräte erscheinen, muss eine Crew gewählt werden.",
} as const;
